import React from "react";
import { Form, Label, Divider } from "semantic-ui-react";
import RightLabel from "react-lib/apps/common/RightLabel";
import { useIntl } from "react-intl";
interface SubFormViewerProps {
  data?: any[] | Record<string,any>;
  fieldList?: any[];
  fieldMap?: Record<string,any>;
}

const DEFAULT_PROPS = {
  data: {},
  fieldList: [],
  fieldMap: {},
};

const SubFormViewer = React.forwardRef<any,SubFormViewerProps>((propsParam, ref) => {
  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value])=> value !== undefined))
  }
  
  const generateUI = () => {
    let arr = props.data;
    if (!Array.isArray(props.data)) {
      arr = [props.data];
    }
    return arr.map((item, index) => {
      return (
        <>
          {props.fieldList.map((field, subIndex) => {
            return (
              <Form.Group
                inline
                key={index + field + subIndex}
                style={{ ...(!Object.keys(item).includes(field) && props.isFallRisk && { display: "none" }) }}
              >
                <Form.Field width={7}>
                  <RightLabel>
                    <Label size="large" style={styles.labelText}>
                      {props.fieldMap[field]}:
                    </Label>
                  </RightLabel>
                </Form.Field>
                <Form.Field width={9}>
                  <Label className="fluidLabel" size="large">
                    {item[field] ? item[field] : "-"}
                  </Label>
                </Form.Field>
              </Form.Group>
            );
          })}
          <Divider />
        </>
      );
    });
  };

  return <Form>{generateUI()}</Form>;
});

const styles = {
  labelText: {
    backgroundColor: "#f3f3f3",
    color: "black",
    lineHeight: "1.6em",
  },
};




export default React.memo(SubFormViewer);
SubFormViewer.displayName = "SubFormViewer";

